// Admin Section - Administrative dashboard and management tools
// Follows the Section, Component & Manager System architecture

import React, { useEffect } from 'react';
import { MainLayout } from '../../components/Layout';
import { AdminManager } from './managers/admin-manager';
import { useManager } from '../../core';
import { useSectionPayload } from '../../managers/navigation-manager';
import { logger } from '../../core';
import { AdminHeader, AdminNavigationGrid, AdminLoading } from './components';
import './AdminSection.css';

export function AdminSection() {
  const { manager, isInitialized } = useManager(AdminManager);
  const { payload } = useSectionPayload();

  // Handle notification payloads
  useEffect(() => {
    if (payload?.fromNotification) {
      logger.log({
        tags: 'admin|notification',
        color1: 'blue'
      }, 'Processing notification payload:', payload);

      // Handle different notification actions
      if (payload.action) {
        handleNotificationAction(payload);
      }

      // Show notification alert if it's a high-priority notification
      if (payload.priority === 'urgent' || payload.priority === 'high') {
        showNotificationAlert(payload);
      }
    }
  }, [payload]);

  const handleNotificationAction = (notificationPayload) => {
    const { action, data } = notificationPayload;

    switch (action) {
      case 'highlight_user':
        // Could scroll to user in users section
        logger.log({
          tags: 'admin|notification|action',
          color1: 'green'
        }, 'Highlighting user:', data?.userId);
        break;

      case 'open_billing':
        // Could navigate to billing section
        logger.log({
          tags: 'admin|notification|action',
          color1: 'green'
        }, 'Opening billing section for:', data);
        break;

      case 'system_alert':
        // Could highlight system status
        logger.log({
          tags: 'admin|notification|action',
          color1: 'yellow'
        }, 'System alert received:', data);
        break;

      default:
        logger.log({
          tags: 'admin|notification|action',
          color1: 'blue'
        }, 'Unknown notification action:', action, data);
    }
  };

  const showNotificationAlert = (notificationPayload) => {
    // For now, just log the alert. In a real implementation,
    // you could show a toast notification or modal
    logger.log({
      tags: 'admin|notification|alert',
      color1: 'red'
    }, 'URGENT NOTIFICATION:', notificationPayload.notificationTitle, notificationPayload.notificationBody);
  };

  if (!isInitialized) {
    return (
      <MainLayout>
        <AdminLoading
          title="Loading Admin Panel"
          subtitle="Setting up administrative tools..."
        />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="admin-container">
        {/* Admin Header */}
        <AdminHeader />

        {/* Admin Navigation Grid */}
        <AdminNavigationGrid manager={manager} />
      </div>
    </MainLayout>
  );
}